import { merge } from 'lodash-es';
import { CHART_TYPES } from '../enums';

const findMinMaxTimeValues = config => {
  let min; let max;

  config?.series?.forEach(series => {
    const timeDimensionIndex = series?.aggregation?.dimensions?.findIndex(({ isTime }) => isTime);

    if ((!timeDimensionIndex && timeDimensionIndex !== 0) || timeDimensionIndex === -1) {
      return;
    }

    series.aggregation.data.forEach(dataPoint => {
      const timeValue = new Date(dataPoint.dimensions[timeDimensionIndex]);
      if (!min || min > timeValue) {
        min = timeValue;
      }
      if (!max || max < timeValue) {
        max = timeValue;
      }
    });
  });

  return { min, max };
};

const setTimeUnit = ({ min, max }) => {
  const second = 1000; // in milli
  const minute = 60 * second;
  const hour = 60 * minute;
  const day = 24 * hour;
  const month = 30 * day;

  const diff = max - min;
  if (diff <= hour || diff === day) {
    return 'minute';
  }
  if (diff < day * 2) {
    return 'hour';
  }
  if (diff < month) {
    return 'day';
  }
  return 'week';
};


export default (config, chartJSConfig) => {
  const { xAxisType } = config;
  const isTimeAxisType = [
    'SINGLE_TIME_FIELD',
    'SINGLE_TIME_FIELD_SINGLE_NON_TIME_FIELD'
  ].includes(xAxisType);

  if (!isTimeAxisType) {
    return chartJSConfig;
  }

  const { min, max } = findMinMaxTimeValues(config);
  const timeUnit = setTimeUnit({ min, max });
  const isBarChart = config?.series[0]?.seriesType?.toLowerCase() === CHART_TYPES.BAR;

  const x = {
    ticks: {
      source: 'data',
      stepSize: 1,
      align: isBarChart ? 'center' : 'start',
      autoSkip: true,
      autoSkipPadding: 20,
      callback: (value, index, values) => {
        // Hide the last tick with an empty string if it's not a bar chart
        return (index === (values.length - 1) && !isBarChart)
          ? ''
          : value;
      },
    },
    type: 'time',
    time: {
      unit: timeUnit,
      displayFormats: {
        week: 'MMM DD, YYYY',
        quarter: 'MMM YYYY',
        hour: 'HH:mm',
        minute: 'HH:mm'
      }
    }
  };

  const configObject = { options: { scales: { x } } };

  return merge(chartJSConfig, configObject);
};
